import { FormattedMessage } from 'react-intl';

import type { TemplatesTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './TemplateGalleryContentError.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import errorPagePng from 'resources/images/templates/error-page.png';

export const TemplateGalleryContentError = () => {
  return (
    <div
      className={styles.TemplateGalleryContentErrorContainer}
      data-testid={getTestId<TemplatesTestIds>(
        'templates-gallery-content-error',
      )}
    >
      <img
        alt=""
        role="presentation"
        className={styles.errorPageImage}
        src={errorPagePng}
      />
      <div className={styles.errorMessageContainer}>
        <p className={styles.errorMessage}>
          <FormattedMessage
            id="templates.templates.hmmm-we-couldnt-load-this-page"
            defaultMessage="Hmmm...we couldn't load this page."
            description="The error message displayed when a template gallery page fails to load."
          />
        </p>
        <p className={styles.errorMessage}>
          <FormattedMessage
            id="templates.templates.try-refreshing-or-coming-back-later"
            defaultMessage="Try refreshing or coming back later."
            description="The message displayed on the error page to encourage users to try refreshing or coming back later."
          />
        </p>
      </div>
    </div>
  );
};
